import pages from "../pages.json"


export function usePage(slug: string): Page | undefined {
    return pages.find(page => page.slug === slug)
}

